import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import { initReactI18next } from "react-i18next";
import { translations } from "./common/translations";

// https://github.com/i18next/i18next-browser-languageDetector
const languageDetectorOptions = {
  // order and from where user language should be detected
  order: ["localStorage"],
  // keys or params to lookup language from
  lookupLocalStorage: "language",
  // cache user language on
  caches: ["localStorage"],
};

i18n.use(LanguageDetector).init({
  detection: languageDetectorOptions,
});

i18n.use(initReactI18next).init({
  debug: false,
  defaultNS: "common",
  fallbackLng: "fi",
  interpolation: {
    escapeValue: false, // not needed for react as it escapes by default
  },
  resources: {
    en: {
      ...translations.en,
      skills: {
        ...translations.skills.en,
      },
      certifications: {
        ...translations.certifications.en,
      },
      languages: {
        ...translations.languages.en,
      },
    },
    fi: {
      ...translations.fi,
      skills: {
        ...translations.skills.fi,
      },
      certifications: {
        ...translations.certifications.fi,
      },
      languages: {
        ...translations.languages.fi,
      },
    },
    sv: {
      ...translations.sv,
      skills: {
        ...translations.skills.sv,
      },
      certifications: {
        ...translations.certifications.sv,
      },
      languages: {
        ...translations.languages.sv,
      },
    },
  },
});

export default i18n;
